"use client";

import { useEffect, useRef } from "react";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { MainPaneLoader } from "@/components/MainPaneLoader";
import { codesmithDesktopBridge } from "@/lib/codesmithSurface";

export default function OrgHome() {
  const router = useRouter();
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (router.isReady && !hasNavigated.current) {
      const { org, ...queryParams } = router.query;
      if (org) {
        hasNavigated.current = true;
        // Preserve query parameters (like ?support=open) when redirecting
        const queryString = new URLSearchParams(
          Object.entries(queryParams).map(([key, value]) => [
            key,
            Array.isArray(value) ? value[0] ?? "" : value || "",
          ]),
        ).toString();
        const landing = codesmithDesktopBridge() ? "sessions" : "home";
        const newPath = `/${org}/${landing}${
          queryString ? `?${queryString}` : ""
        }`;
        router.replace(newPath);
      }
    }
  }, [router, router.isReady, router.query]);

  return <MainPaneLoader />;
}
